<template>
  <div class="viq-upsell">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect x="3" y="6" width="8" height="7" rx="1" stroke="currentColor" stroke-width="1.2" />
      <path d="M5 6V4a2 2 0 014 0v2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    </svg>
    <span>Premium content - Upgrade to access expert analysis</span>
  </div>
</template>

<script>
export default {
  name: "ViqExpertUpsell",
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-upsell {
  display: flex;
  align-items: center;
  gap: $viq-space-sm;
  margin-top: $viq-space-sm;
  padding: $viq-space-sm $viq-space-md;
  background: $viq-upsell-bg;
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: $viq-radius-sm;
  font-size: $viq-font-xs;
  color: #92400e;
  font-weight: 500;
}
</style>
